export const getCurrentUserFullName = state => state.user.fullName

export const getCurrentUserEmail = state => state.appState.user.email
